import {
  Component,
  forwardRef,
  Inject,
  Input,
  OnInit
}                             from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DomSanitizer }       from '@angular/platform-browser';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';
import { NgForm }             from '@angular/forms';
import { TranslateService }   from '@ngx-translate/core';
import { UIRouter }           from '@uirouter/core';

import { ApiService }                     from '../api/api.service';
import { ChargifyService }                from '../chargify/chargify.service';
import { CodeTypeModel }                  from '../core/models/code-type';
import { CompanyCountryValidationsModel } from '../companies/models/company.country-validations';
import { CompanyService }                 from './company.service';
import { CompanySettingsModel }           from '../companies/models/company.settings';
import { RadioModel }                     from '../shared/controls/radio-group/typings/radio';
import { UtcOffset }                      from '../companies/models/utc-offset';

import brakeIcon      from 'icons/brake-primary.svg';
import caravanIcon    from 'icons/caravan-primary.svg';
import suspensionIcon from 'icons/suspension-primary.svg';
import tireIcon       from 'icons/tire-primary.svg';

@Component({
  selector   : 'wor-company-set-up',
  template: require('./company.set-up.component.html')
})
export class CompanySetUpComponent implements OnInit {
  _companyTypes         : Array<RadioModel>;
  areTaxSettingsVisible : boolean
  taxGroup              : any = {};
  utcOffsets            : Array<UtcOffset>;

  public brakeIcon      = this.sanitizer.bypassSecurityTrustHtml(brakeIcon);
  public caravanIcon    = this.sanitizer.bypassSecurityTrustHtml(caravanIcon);
  public suspensionIcon = this.sanitizer.bypassSecurityTrustHtml(suspensionIcon);
  public tireIcon       = this.sanitizer.bypassSecurityTrustHtml(tireIcon);

  @BlockUI('companySetUpBlock') block: NgBlockUI;

  @Input() company        : any;
  @Input() companySettings: CompanySettingsModel;
  @Input() states         : Array<CodeTypeModel>;
  @Input() validations    : CompanyCountryValidationsModel;

  @Input() set companyTypes ( _companyTypes : Array<CodeTypeModel> ) {
    this._companyTypes = _companyTypes.map(( type : CodeTypeModel ) => {
      var companyType : RadioModel = {
        name : type.code,
        value: type.code
      };

      companyType.label = this.translateService.instant(type.language_label);

      switch (type.code) {


        case 'AUTO_ELECTRICIANS':
          companyType.icon = 'electrician';
          break;
        case 'TYRE_OUTLETS':
          companyType.icon      = this.tireIcon;
          companyType.iconTheme = 'inline';
          break;
        case 'TRUCK_REPAIRERS':
          companyType.icon = 'truck';
          break;
        case 'BRAKE_AND_CLUTCH':
          companyType.icon      = this.brakeIcon;
          companyType.iconTheme = 'inline';
          break;
        case 'SUSPENSION_SPECIALISTS':
          companyType.icon      = this.suspensionIcon;
          companyType.iconTheme = 'inline';
          break;
        case 'CARAVAN_RV_REPAIRERS':
          companyType.icon      = this.caravanIcon;
          companyType.iconTheme = 'inline';
          break;
        case 'BICYCLE_REPAIRERS':
          companyType.icon = 'bicycle';
          break;
        case 'FARM_MACHINERY_REPAIRERS':
          companyType.icon = 'tractor';
          break;
        case 'MARINE_AND_BOAT_REPAIRERS':
          companyType.icon = 'boat';
          break;
        case 'MOTORCYCLE_AND_SCOOTER_REPAIRERS':
          companyType.icon = 'motorcycle';
          break;
        case 'AUTO_MECHANICAL':
        default:
          companyType.icon = 'workshops';
          break;


      }

      return companyType;
    });
  }

  constructor (
    private activeModal     : NgbActiveModal,
    private apiService      : ApiService,
    private chargifyService : ChargifyService,
    @Inject(forwardRef(() => CompanyService)) public  companyService  : CompanyService,
    private router          : UIRouter,
    private sanitizer       : DomSanitizer,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.areTaxSettingsVisible = !this.companyService.country([
      'australia',
      'newZealand',
      'unitedKingdom'
    ]);

    if ( this.company.state ) {


      this.handleStateChange();


      };


    }

  getAndSetTaxGroup () : Promise<any> {
    return this.apiService.get('/tax_groups')
    .then(( groups : Array<any> ) => {
      this.taxGroup = groups.find(group => group.id === this.company.tax_group_id);

      this.taxGroup.tax_group_items_attributes.forEach(( item ) => {
        if (this.isStateTax(item)) {
          this.taxGroup.stateTaxRate = item.tax_rate;
        }

        else if (this.isLocalTax(item)) {
          this.taxGroup.localTaxRate = item.tax_rate;
        }
      });

      return this.taxGroup;
    });
  }

  getUtcOffsetsForState ( state = this.company.state ) : Promise<Array<UtcOffset>> {
    return this.apiService.get('/company/get_utc_offset_type', [
      this.company.country_code,
      state
    ]);
  }

  handleStateChange ( state = this.company.state ) : void {
    this.block.start();

    this.getUtcOffsetsForState(state)
    .then(( utcOffsets : Array<UtcOffset> ) => {
      this.utcOffsets = utcOffsets;

      if ( utcOffsets.length === 1 ) {


        this.companySettings.utc_description = utcOffsets[0].code;


        this.updateUtcSettings();


      }

      return this.apiService.post('/company/set_region_tax_rate', {
        country_code: this.company.country_code,
        state       : this.company.state
      });
    })
    .then(() => this.apiService.get('/company'))
    .then(( company ) => {
      this.company.tax_group_id       = company.tax_group_id;
      this.company.tax_group_name     = company.tax_group_name;
      this.company.tax_name           = company.tax_name;
      this.company.purchases_tax_rate = company.purchases_tax_rate;
      this.company.sales_tax_rate     = company.sales_tax_rate;

      return this.companyService.hasMultiTax()
        ? this.getAndSetTaxGroup()
        : Promise.resolve();
    })
    .finally(() => this.block.stop());
  }

  isLocalTax ( item : any = {} ) : boolean {


    return item.tax_type === 'Local Tax'
      || item.tax_type === 'GST';


  }

  isStateTax ( item : any = {} ) : boolean {


    return item.tax_type === 'State Tax'
      || item.tax_type === 'PST'
      || item.tax_type === 'QST';


  }

  save ( form : NgForm ) : Promise<any> {
    this.block.start();

    return this.apiService.patch('/company', this.company, 'company')
      .then(() => this.apiService.patch('/company_settings', this.companySettings, 'company_setting'))
      .then(() => {
        if ( this.companyService.hasMultiTax() ) {
          this.taxGroup.tax_group_items_attributes.forEach(( item ) => {
            if ( this.isStateTax(item) ) {
              item.tax_rate = this.taxGroup.stateTaxRate;
            }
            else if ( this.isLocalTax(item) ) {
              item.tax_rate = this.taxGroup.localTaxRate;
            }
          });

          return this.apiService.patch('/tax_group', this.taxGroup, 'tax_group');
        }

        Promise.resolve(this.taxGroup);
      })
      .then(( data ) => {
        this.activeModal.close(data);

        this.router.stateService.reload();
      })
      .catch(error => this.activeModal.dismiss(error))
      .finally(() => this.block.stop());
  }

  updateUtcSettings ( utcDescription = this.companySettings.utc_description ) : void {


    this.company.utc_offset = this.companyService.getUtcOffsetFromCode(utcDescription, this.utcOffsets);


    };


  }
